import { Button, Form, Input, Modal, Select } from 'antd';
import { toast } from 'react-toastify';
import { useStateContext } from '~/contexts/ContextProvider';
import banks from '~/data/bank';
import { instanceAuth } from '~/utils/axios';
import { useTranslation } from 'react-i18next';
import { NS } from '~/utils/ns';
import { useState } from 'react';
const options = banks.map((bank) => ({
  label: bank.short_name,
  value: bank.short_name,
}));

const ModalChangeBank = ({ isOpen, setIsOpen }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation([NS['profile']]);
  const { agency, setAgency } = useStateContext();
  const handleCancel = () => {
    setIsOpen(false);
  };

  const handleSubmit = async (data) => {
    try {
      setIsLoading(true);
      data.nameuser = agency.bank_user;
      const res = await instanceAuth().post('/add-bank', data);
      if (!res?.status) return toast.error(t(`common:${res?.errCode}`));
      toast.success(t('common:success'));
      setAgency((prev) => ({
        ...prev,
        bank_name: data.nameBank,
        bank_number: data.stk,
      }));
      handleCancel();
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal open={isOpen} onOk={handleCancel} onCancel={handleCancel} footer={null}>
      <h3 className="font-semibold text-xl text-center">{t('themttnganhang')}</h3>
      <Form layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          label={t('tennganhang')}
          name="nameBank"
          required
          rules={[{ required: true, message: t('vuilongnganhang') }]}>
          <Select
            placeholder={t('chonnganhang')}
            options={options}
            showSearch
            filterOption={(input, option) =>
              option.label.toLowerCase().includes(input.toLowerCase())
            }
          />
        </Form.Item>
        <Form.Item
          label={t('stk')}
          name="stk"
          required
          rules={[
            {
              required: true,
              message: t('vuilongnhapstk'),
            },
          ]}>
          <Input placeholder={t('nhaptkthuhuong')} />
        </Form.Item>
        <Form.Item label={t('tenchutk')} name="nameuser">
          <Input disabled placeholder={agency?.bank_user} />
        </Form.Item>
        <div className="flex justify-end gap-3">
          <Button onClick={handleCancel}>{t('common:cancel')}</Button>
          <Button className="bg-blue-500 text-white" htmlType="submit" loading={isLoading}>
            {t('themnganhang')}
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default ModalChangeBank;
